import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "components/Navbar"; // Assuming Navbar exists
import { useNavigate } from "react-router-dom";

const apiUrl = process.env.REACT_APP_API_URL 

const ResetPasswordAfterLogin = () => {
  const [token, setToken] = useState(null);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();
  const username = sessionStorage.getItem("username");
  
  useEffect(() => {
    const token = sessionStorage.getItem('token');
    setToken(token)
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage(""); // Clear previous errors
    setSuccessMessage(""); // Clear previous success messages

    try {
      // Send oldPassword and newPassword to the backend for verification
      const response = await axios.post(`${apiUrl}/change_password`, 
        {
          oldPassword,
          newPassword,
        },
        {
          params: {
            token
          }
        }
        
      );

      // Handle backend response
      if (response.data.success) {
        setSuccessMessage("Password has been reset successfully!");
        setTimeout(() => {
          navigate("/login"); // Redirect to login after success
        }, 2000);
      } else {
        setErrorMessage(response.data.message || "Error resetting password.");
      }
    } catch (error) {
      setErrorMessage(
        error.response?.data?.message || "An error occurred. Please try again."
      );
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-900">
      {/* Navbar */}
      <Navbar />

      {/* Reset Password Form */}
      <div className="flex flex-col items-center w-[34%] md:w-full gap-3 px-9 py-12 md:py-5 sm:p-5 bg-gray-900_02 mx-auto mt-16">
        <h1 className="self-stretch text-center text-[20px] font-medium leading-[140%] text-white-a700">
          Change Your Password
        </h1>
        <div className="flex flex-col items-center gap-3 self-stretch">
          <form
            className="flex flex-col gap-3 self-stretch"
            onSubmit={handleSubmit}
          >
            {/* Old Password Input */}
            <input
              type="password"
              placeholder="Enter old password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              required
              className="bg-gray-900 text-white-a700 p-3 rounded-md"
              style={{
                backgroundColor: "var(--gray_900)",
                borderColor: "var(--gray_900_02)",
                color: "var(--white_a700)",
              }}
            />

            {/* New Password Input */}
            <input
              type="password"
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              className="bg-gray-900 text-white-a700 p-3 rounded-md"
              style={{
                backgroundColor: "var(--gray_900)",
                borderColor: "var(--gray_900_02)",
                color: "var(--white_a700)",
              }}
            />

            {/* Feedback Messages */}
            {errorMessage && (
              <p className="text-red-500 text-sm mt-1">{errorMessage}</p>
            )}
            {successMessage && (
              <p className="text-green-500 text-sm mt-1">{successMessage}</p>
            )}

            {/* Submit Button */}
            <button
              type="submit"
              className="px-[34px] py-3 bg-indigo-600 text-white-a700 rounded-md hover:bg-indigo-500"
            >
              Reset Password
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordAfterLogin;
